<template>
  <div class="Fuell-Table">
    <div class="Fuell-Table--header">
      <div class="Fuell-Table--item">
        <span v-t="{ path: 'NAME' }"></span>
      </div>
      <div class="Fuell-Table--item">
        <span v-t="{ path: 'USER' }"></span>
      </div>
      <div class="Fuell-Table--item">
        <span v-t="{ path: 'budget_detail_budget_assigned' }"></span>
      </div>
      <div class="Fuell-Table--item">
        <span v-t="{ path: 'budget_detail_budget_spent' }"></span>
      </div>
      <div class="Fuell-Table--item">
        <span v-t="{ path: 'budget_detail_budget_available' }"></span>
      </div>
      <div class="Fuell-Table--item">
        <span v-t="{ path: 'budget_detail_budgter_spent_vs_available' }"></span>
      </div>
      <div class="Fuell-Table--item">
        <span v-t="{path: 'users_identifier'}"></span>
      </div>
      <div class="Fuell-Table--item">
        <span v-t="{path: 'users_expense_center'}"></span>
      </div>
    </div>

    <div class="Fuell-Table--content">
      <template v-if="userBudgets.length > 0 && !isCallingUserBudgets">
        <user-budgets-table-row
          v-for="budget in userBudgets"
          :budget="budget"
          :key="budget.id"
        ></user-budgets-table-row>
      </template>
      <div
        v-else-if="userBudgets.length === 0 && !isCallingUserBudgets"
        class="Fuell-Table--empty"
      >
        <p>
          {{ $t('budget_detail_user_not_assigned') }}
          <router-link
            to="/budgets"
            class="link"
          >
            {{ $t('budget_detail_assign_user') }}
          </router-link>
        </p>
      </div>
      <div
        class="Fuell-Table--spinner"
        v-if="isCallingUserBudgets"
      >
        <spinner></spinner>
      </div>
    </div>
  </div>
</template>

<script>
import UserBudgetsTableRow from './UserBudgetsTableRow'
import Spinner from '@/components/Commons/Spinner'
import _paginationHandlerMixin from '@/components/Commons/_mixins/_paginationHandlerMixin'
export default {
  name: 'UserBudgetsTable',
  components: { UserBudgetsTableRow, Spinner },
  mixins: [_paginationHandlerMixin],
  computed: {
    userBudgets () {
      return this.$store.getters['UsersStore/userBudgets'] || []
    },
    isCallingUserBudgets () {
      return this.$store.getters['UsersStore/isCallingUserBudgets']
    },
    currentPage () {
      return this.$store.getters['UsersStore/userBudgetsCurrentPage']
    },
    lastPage () {
      return this.$store.getters['UsersStore/userBudgetsLastPage']
    }
  },
  methods: {
    nextPage () {
      this.$store.dispatch('UsersStore/nextUserBudgetsPage', {
        pagination: true,
        filters: {
          'user.id': this.$route.params.id,
          'budget.status.code': 'ACTIVE'
        }
      })
    }
  }
}
</script>

<style scoped>
@media (min-width: 992px) {
  .GridTable--users {
    grid-template-columns: repeat(6, 1fr);
  }
}
</style>

<style lang="scss" scoped>
@import "@/assets/styles/tables/user-budgets.scss";
</style>
